import React from 'react';
import PropTypes from 'prop-types';
import SanitizedHTML from 'react-sanitized-html';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircle,
  faPhone,
  faCalendarAlt,
  faEnvelope
} from '@fortawesome/pro-solid-svg-icons';

export default class RecentActivities extends React.Component {
  static propTypes = {
    activities: PropTypes.arrayOf(PropTypes.shape({
      body: PropTypes.string,
      calendarImport: PropTypes.bool,
      completedAt: PropTypes.string.isRequired,
      hasCrmEmail: PropTypes.bool,
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    })).isRequired
  };

  render() {
    const recentActivities = [];
    this.props.activities.slice(0, 3).forEach((activity) => {
      if (activity) {
        recentActivities.push(this.renderActivity(activity));
      }
    });

    return (
      <div>
        {this.props.activities.length > 0 &&
          <div>
            <div className="fw-semibold"> Recent Activity </div>
            <div className="recent-activity-block position-relative pe-1 py-1">
              <div className="solid-line"></div>
              {recentActivities}
            </div>
          </div>
        }
      </div>
    );
  }

  renderActivity(activity) {
    let icon = '', title = '', iconBackground = '';

    switch (activity.type) {
    case 'call':
      icon = faPhone;
      title = activity.title;
      iconBackground = 'call-icon';
      break;
    case 'meeting':
      icon = faCalendarAlt;
      title = 'Meeting @ ' + activity.title;
      iconBackground = 'meeting-icon';
      break;
    default:
      icon = faEnvelope;
      title = activity.title;
      iconBackground = 'email-icon';
      break;
    }

    return (
      <div className="d-flex position-relative py-1 pe-1 row align-items-center" key={activity.id}>
        <div className="fa-2x col-1 me-2">
          <span className="fa-layers fa-fw">
            <FontAwesomeIcon className={iconBackground} icon={faCircle}/>
            <FontAwesomeIcon
              className="inner-icon"
              icon={icon}
              transform="shrink-8"
            />
          </span>
        </div>
        <div className="col-7">
          <div className="fw-bold"> {title} </div>
          {this.renderActivityBody(activity)}
        </div>
        <div className="col-3 fs-small text-end">
          <div className="text-muted"> {activity.completedAt} </div>
        </div>
      </div>
    );
  }

  renderActivityBody(activity) {
    if (activity.hasCrmEmail || activity.calendarImport) {
      return <SanitizedHTML className="fade-lock" html={activity.body} />;
    }

    return <div className="text-truncate text-muted"> {activity.body} </div>;
  }
}
